import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=1451e9a8&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealerMobile: require('/usr/src/motec/components/dealer/Mobile.vue').default,BackToTopButton: require('/usr/src/motec/components/BackToTopButton.vue').default})
